var SENTRY_RELEASE;SENTRY_RELEASE={name: "Pointcare", version: "1.0.0"};